import { useState } from "react"
import { flushSync } from "react-dom"
import { useTranslation } from "react-i18next"
import { PatchSummary } from "./patch-summary"
import { Poster } from "./poster"
import "./patchnotes.css"

export default function PatchNotes() {
  const { t } = useTranslation()
  const PATCHES = [
    "6.11.0-chinese",
    "6.10.5-chinese",
    "6.10.4-chinese",
    "6.10.3-chinese",
    "6.10-chinese",
    "6.9.3-chinese",
    "6.9.2-chinese",
    "6.9-update-0420",
    "6.9-chinese",
    "6.9",
    "6.8",
    "6.7",
    "6.6",
    "6.5",
    "6.4",
    "6.3",
    "6.2",
    "6.1",
    "6.0",
    "5.10",
    "5.9",
    "5.8",
    "5.7",
    "5.6",
    "5.5",
    "5.4",
    "5.3",
    "5.2",
    "5.1",
    "5.0",
    "4.9",
    "4.8",
    "4.7",
    "4.6",
    "4.5",
    "4.4",
    "4.3",
    "4.2",
    "4.1",
    "4.0",
    "3.10",
    "3.9",
    "3.8"
  ]

  const [selectedPatch, setSelectedPatch] = useState<string | null>(null)

  const viewTransition = (transition: () => void) => {
    // Use View Transition API if available
    if (
      "startViewTransition" in document &&
      typeof document.startViewTransition === "function"
    ) {
      document.startViewTransition(() => {
        flushSync(() => {
          transition()
        })
      })
    } else {
      transition()
    }
  }

  const handlePosterClick = (version: string) =>
    viewTransition(() => {
      setSelectedPatch(selectedPatch === version ? null : version)
    })

  const handleBackClick = () =>
    viewTransition(() => {
      setSelectedPatch(null)
    })

  if (selectedPatch) {
    return (
      <div className="patchnotes-detail-view">
        <div className="detail-content">
          <div className="detail-poster">
            <Poster version={selectedPatch} isDetailed />
          </div>
          <div className="detail-notes">
            <button
              className="close-btn"
              onClick={handleBackClick}
              style={{ float: "right", marginLeft: "2em" }}
            >
              🗙
            </button>
            <PatchSummary version={selectedPatch} />
          </div>
        </div>
      </div>
    )
  }

  return (
    <ul className="patchnotes-grid" role="list">
      {PATCHES.map((v) => (
        <li
          key={v}
          style={{ viewTransitionName: `poster-${v}` }}
          role="listitem"
        >
          <Poster version={v} onClick={() => handlePosterClick(v)} />
        </li>
      ))}
    </ul>
  )
}
